"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const GuideLink_1 = __importDefault(require("../../GuideLink"));
function SampleDataSubheading({ emoji, heading, subtextComponent }) {
    return (core_1.jsx("div", { css: { display: 'flex' } },
        core_1.jsx("div", { css: { fontSize: 40, marginRight: 10 } },
            core_1.jsx(common_components_1.Emoji, { label: emoji.label, symbol: emoji.symbol })),
        core_1.jsx("div", { css: { lineHeight: 1.6 } },
            core_1.jsx(design_system_1.Text, { tag: "p", type: "subtitle700" }, heading),
            core_1.jsx(design_system_1.Text, { color: "grey700", type: "altText900" },
                subtextComponent,
                ' ',
                core_1.jsx(GuideLink_1.default, { base: "/help/create/basics/", slug: "set-up-your-zap-trigger", step: "test-your-trigger" }, "Learn more about test data"),
                "."))));
}
exports.default = SampleDataSubheading;
